import React from "react"
import { Button } from "components/button"
import { useMutation, useQueryClient } from "react-query"
import Axios from "axios"
import { useSnackbarContext } from "components/snackbar"
import { MdCloudDownload } from "react-icons/md"
import { useTranslation } from "react-i18next"

const ExportAll = () => {
  const { t } = useTranslation()
  const tBase = "views.admin.export.components.ExportAll"
  const tr = (key: string) => t(`${tBase}.${key}`)

  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()

  const exportAllMutation = useMutation(
    async () => {
      const response = await Axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/export-tool/start-all`,
        {}
      )
      return response.data
    },
    {
      onSuccess: (data) => {
        showSnackbar(
          tr("All exports started! You will receive an email for each when ready.")
        )
        // Immediately refetch export jobs to show the new exports
        queryClient.invalidateQueries("export-jobs")
      },
      onError: (error) => {
        console.error(error)
        showSnackbar(tr("Failed to start exports"))
      }
    }
  )

  return (
    <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-md p-6 text-white">
      <h2 className="text-xl font-bold mb-2">{tr("Export All Data")}</h2>
      <p className="text-blue-100 mb-4">
        {tr("Start all exports at once. You will receive a separate email for each export type when ready.")}
      </p>
      <Button
        className="bg-white text-blue-600 hover:bg-blue-50"
        isLoading={exportAllMutation.isLoading}
        onClick={() => exportAllMutation.mutate()}
      >
        <MdCloudDownload style={{ marginRight: "8px", fontSize: "20px" }} />
        {tr("Export All")}
      </Button>
    </div>
  )
}

export default ExportAll
